// extracted by mini-css-extract-plugin
export default {"padding-x":"20","list":"virtualizedLoader_list__vM5ty"};